import { Component, OnInit, ViewChild } from "@angular/core";
import { environment } from "../../../environments/environment";
import { PoPageDynamicTableActions, PoPageDynamicTableCustomAction, PoPageDynamicTableCustomTableAction, PoPageDynamicTableFilters } from "@po-ui/ng-templates";
import { PoBreadcrumb, PoCheckboxGroupComponent, PoCheckboxGroupOption, PoDatepickerRange, PoDatepickerRangeComponent, PoModalComponent, PoNotificationService } from "@po-ui/ng-components";
import { SchemaBuilderService } from "../../core/menu/schema-builder.service";
import { ReportsService } from "./reports.service";

@Component({
  selector: 'app-empresa',
  templateUrl: './reports.component.html',
  styleUrl: './reports.component.css',
  standalone: false
})
export class ReportsComponent implements OnInit {

  @ViewChild('modalRequestreport') poModalComponent!: PoModalComponent;
  @ViewChild('CndGroup') poCndCheckboxGroupComponent!: PoCheckboxGroupComponent;
  @ViewChild('datepickerRange') poDatepickerRange!: PoDatepickerRangeComponent;


  readonly breadcrumb: PoBreadcrumb = {
    items: [{ label: 'Home', link: '/home' }, { label: 'Relatórios' }, { label: 'Relatórios Domínio' }]
  };
  readonly systemOptions: Array<PoCheckboxGroupOption> = [

    { value: '1', label: 'Relatório Tomados' },
    { value: '2', label: 'Relatório Prestados' },
    { value: '3', label: 'Desoneração', },

  ];
  readonly pageActions: PoPageDynamicTableCustomAction[] = [
    {
      label: 'Novo Relatório',
      icon: 'an an-newspaper',
      action: this.showReportRequestModal.bind(this),
    }
  ];
  tableCustomActions: Array<PoPageDynamicTableCustomTableAction> = [
    {
      label: 'Download de Rellatório',
      icon: 'an an-file-csv',
      action: this.downloadCsvReport.bind(this),
    }
  ];
  readonly actions: PoPageDynamicTableActions = {

    //new: '/empresa-edit/',
    //edit: '/empresa-edit/:id',
    //duplicate: '/clientes-edit/',
    remove: true,

  };

  readonly serviceApi = environment.apiUrl + '/v1/dominio-reports';
  fields: Array<PoPageDynamicTableFilters> = [];
  event: string = '';
  endDate!: string | Date;
  startDate!: string | Date;
  datepickerRange!: PoDatepickerRange;

  constructor(private readonly schemaBuilderService: SchemaBuilderService,
    private readonly reportService: ReportsService,
    private readonly poNotificationService: PoNotificationService) {
    this.schemaBuilderService.getTableSchema("reports").subscribe((data) => {
      this.fields = data;
    });
  }

  ngOnInit() {  }

  showReportRequestModal() {
    this.poModalComponent.open();
  }
  formatDate(date: string | Date): string {
    if (date instanceof Date) {
      return date.toISOString().split('T')[0]; // Formata a data como 'YYYY-MM-DD'
    }
    return date;
  }
  requestReport()
  {
    const selectedValues: string[] = this.poCndCheckboxGroupComponent.checkedOptionsList;
    const startDate = this.formatDate(this.poDatepickerRange.dateRange.start);
    const endDate = this.formatDate(this.poDatepickerRange.dateRange.end);
    for (const value of selectedValues) {
      if (value === '1') {
        this.reportService.requestTomados(startDate, endDate).subscribe();
      } else if (value === '2') {
        this.reportService.requestPrestados(startDate, endDate).subscribe();
      } else if (value === '3') {
        this.reportService.requestDesonerados().subscribe();
      }
    this.poNotificationService.success('Relatórios solicitados com sucesso!');
    this.poModalComponent.close();

    }
  }
  changeEvent(event: string) {
    this.event = event;
  }

  downloadCsvReport(report: any) {
    const csvContent = report.csvReport;
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `relatorio_${report.reportName}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }
}
